import React from 'react';
import { observable, action, makeAutoObservable } from 'mobx';
import getTime from 'src/utils/periodTime';

export class DateRangeFormState {
    @observable public isFocus: boolean = false;
    @observable public isValidStartDate: boolean = false;
    @observable public isValidEndDate: boolean = false;
    @observable public newDate: string | null = null;

    public constructor() {
        makeAutoObservable(this);
    }

    @action public setFocus = (focus: boolean) => {
        return (): boolean | undefined => {
            if (focus === this.isFocus) {
                return;
            }

            this.isFocus = focus;
        };
    };

    @action public onBlurStartDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.isValidStartDate = false;
        }
        this.isValidStartDate = true;
    };

    @action public onBlurEndDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.isValidEndDate = false;
        }
        this.isValidEndDate = true;
    };

    public changeTime = (time: string, handleOnUpdateDate: (startDate: Date, endDate: Date) => void): void => {
        const newTime = getTime(time);

        if (newTime === undefined) {
            return;
        }

        const newStartDate = new Date(newTime.startDate);
        const newEndDate = new Date(newTime.endDate);

        handleOnUpdateDate(newStartDate, newEndDate);
    };
}
